import {useAtom} from 'jotai';
import {useEffect} from 'react';
import toast from '@/components/HotToast';
import {useGA4WithParams} from '@/hooks/tracking';
import {mapActionModeAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {MapActionTypes} from '@/map/enums';
import {useVisibleZoomLevel} from '@/map/hooks';
import {ToolboxItemProps} from './';
import {ReactComponent as MenuIcon} from './assets/ruler.svg';
import {ToolboxItem} from './StyledComponents';

const mode = MapActionTypes.ruler;

export const RulerButton = (props: ToolboxItemProps) => {
  const [action, setActionMode] = useAtom(mapActionModeAtom);
  const isAvailableLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.ruler);

  const active = action?.mode === mode;

  const tracking = useGA4WithParams();

  const handleClick = () =>
    setActionMode((prev) => {
      if (prev?.mode === mode) {
        return null;
      } else if (!isAvailableLevel) {
        toast(
          '현재 배율에서는 거리 측정을 할 수 없습니다.<br /><strong>지도를 좀 더 확대</strong>해 주세요.'
        );
        return null;
      }

      tracking('measure_distance_toolbox');
      return {mode};
    });

  useEffect(() => {
    return () => {
      if (active) {
        setActionMode(null);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ToolboxItem {...props} active={active} onClick={handleClick}>
      <MenuIcon />
    </ToolboxItem>
  );
};
